import React from 'react';
import { useSectionStore } from '../../store/sectionStore';
import { useClickStore } from '../../store/clickStore';
import { useStringLayerStore } from '../../store/stringLayerStore';
import { sectionStatusLine } from '../../Utils/sectionMath';

const LABELS = {
  pan: { title: 'Pan', hint: 'Orbit the scene' },
  info: { title: 'Info', hint: 'Click an object for details · Esc to pan' },
  distance: { title: 'Distance', hint: 'Click two points · snaps to collars · Esc to pan' },
  zoom: { title: 'Zoom', hint: 'Click a point to fly there · Esc to pan' },
  color: { title: 'Colour', hint: 'Click an object, then pick a colour · Esc to pan' },
  hide: { title: 'Hide', hint: 'Click an object to turn its layer off · Esc to pan' },
};

const PLACE_HINT = {
  click: 'Click a point to place the section',
  twoPoint: 'Click two points for a vertical section',
  threePoint: 'Click three points for an oblique plane',
  fence: 'Click along a centreline, then Done fence',
  object: 'Click a solid to clip inside/outside/above/below',
};

export default function ToolStatusChip({ clickType, canUndoHide, onUndoHide, onHelp }) {
  const meta = LABELS[clickType] || LABELS.pan;
  const sectionEnabled = useSectionStore((s) => s.enabled);
  const placeMode = useSectionStore((s) => s.placeMode);
  const section = useSectionStore();
  const placing = placeMode && placeMode !== 'idle';
  const digitizing = useStringLayerStore((s) => s.digitizing);
  const draftLen = useStringLayerStore((s) => s.draft.length);
  const planLocked = useClickStore((s) => s.planLocked);
  const lastSnap = useClickStore((s) => s.lastSnap);

  return (
    <div className="pointer-events-auto absolute bottom-3 left-3 z-[70] flex items-center gap-1.5 max-w-[calc(100%-1.5rem)] flex-wrap">
      <div className="rounded-md border border-yellow-600/35 bg-black/90 px-2.5 py-1.5 shadow-lg backdrop-blur-sm">
        <p className="text-[9px] uppercase tracking-[0.16em] text-yellow-500/85">
          {digitizing ? 'Digitise string' : placing ? 'Section place' : meta.title}
        </p>
        <p className="text-[10px] text-zinc-400 leading-tight mt-0.5">
          {digitizing
            ? `Click vertices (${draftLen}) · Esc cancel · Done str to save`
            : placing
              ? PLACE_HINT[placeMode] || 'Click in the scene'
              : meta.hint}
        </p>
      </div>
      {planLocked ? (
        <div className="rounded-md border border-yellow-600/35 bg-black/90 px-2.5 py-1.5 shadow-lg backdrop-blur-sm">
          <p className="text-[9px] uppercase tracking-[0.16em] text-yellow-500/85">Plan</p>
          <p className="text-[10px] text-zinc-400 leading-tight mt-0.5">North up · N to exit</p>
        </div>
      ) : null}
      {lastSnap?.label ? (
        <div className="rounded-md border border-sky-600/35 bg-black/90 px-2.5 py-1.5 shadow-lg backdrop-blur-sm">
          <p className="text-[9px] uppercase tracking-[0.16em] text-sky-400/85">Snap</p>
          <p className="text-[10px] text-zinc-400 leading-tight mt-0.5">{lastSnap.label}</p>
        </div>
      ) : null}
      {sectionEnabled ? (
        <div className="rounded-md border border-yellow-600/35 bg-black/90 px-2.5 py-1.5 shadow-lg backdrop-blur-sm">
          <p className="text-[9px] uppercase tracking-[0.16em] text-yellow-500/85">Section on</p>
          <p className="text-[10px] text-zinc-400 leading-tight mt-0.5 tabular-nums">{sectionStatusLine(section)}</p>
        </div>
      ) : null}
      {canUndoHide ? (
        <button
          type="button"
          className="m-0 h-8 px-2 rounded-md border border-yellow-600/35 bg-black/90 text-[10px] uppercase tracking-wider text-yellow-400 hover:border-yellow-400"
          onClick={onUndoHide}
          title="Undo last hide (U)"
        >
          Undo hide
        </button>
      ) : null}
      <button
        type="button"
        className="m-0 h-8 w-8 rounded-md border border-yellow-600/35 bg-black/90 text-[11px] font-semibold text-yellow-400 hover:border-yellow-400"
        onClick={onHelp}
        title="Shortcuts (?)"
      >
        ?
      </button>
    </div>
  );
}
